<template>
  <el-dialog
    :title=dialogTitle
    :visible.sync="openDialogVisiable"
    width="650px"
    top="10%"
    custom-class="customer-share-dialog"
    :before-close="closeDialog">
    <div :style="{height: (computedHeight-490)+'px'}" class="dialog-body">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane key="linkShare" name="linkShare">
          <span slot="label"><i class="el-icon-cus-link" style="margin-right: 5px;"></i>链接分享</span>
          <div v-if="!isCreateLink">
            <el-form label-position="right" label-width="80px" :model="params">
              <el-form-item label="分享形式">
                <div>
                <!--<div style="display: flex;flex-direction: column">-->
                  <el-radio class="radio-type" v-model="params.needCode" :label=true style="margin-left: -10px;">有提取码：仅限有提取码者可查看，有效保护隐私安全</el-radio>
                  <!--<el-radio class="radio-type" v-model="params.needCode" :label=false style="margin-left: -40px;">无提取码：仅拥有分享链接者可查看，无需提取码</el-radio>-->
                </div>
              </el-form-item>
              <!--<el-form-item>-->
                <!--<span style="margin-left: -234px;margin-right: 24px;">下载此次分享文件是否需要登录</span>-->
                <!--<el-radio-group v-model="params.downloadFlag">-->
                  <!--<el-radio :label=1>是</el-radio>-->
                  <!--<el-radio :label=0>否</el-radio>-->
                <!--</el-radio-group>-->
              <!--</el-form-item>-->
              <el-form-item label="有效期">
                <el-radio-group v-model="params.expireTime" style="width: 100%;">
                  <div style="display: flex;flex-direction: row">
                    <el-radio v-for="(item, idx) in invalidExpireOptions" :key="idx" :label=item.key style="width: 25%;">{{item.value}}</el-radio>
                  </div>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="说明">
                <el-input type="textarea" v-model="params.comment"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div v-else>
            <el-form label-position="right" :model="params" size="mini">
              <el-form-item style="color: #409EFF;font-size: 16px;font-weight: 500">
                <span><i class="el-icon-success" style="margin-right: 12px"></i>成功创建分享链接，{{expireTime}}有效</span>
              </el-form-item>
              <el-form-item>
               <div style="display: flex; flex-direction: row">
                 <el-input v-model="shareUrl" style="margin-right: 12px;" :readonly=true></el-input>
                 <div style="display: flex;flex-direction: column">
                   <el-button type="primary" @click="clickCopyLink">{{copyTips}}</el-button>
                   <span style="color: #409EFF;" v-show="isCopiedLink">复制成功</span>
                 </div>
               </div>
              </el-form-item>
              <el-form-item v-if="params.needCode">
                提取码：{{code}}
              </el-form-item>
              <el-form-item>
                温馨提示：可以将链接发送给微信、QQ等好友～
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <!--<el-tab-pane key="defaultFileShare" name="defaultFileShare" v-if="isCommonFileAdmin">-->
          <!--<span slot="label"><i class="el-icon-document" style="margin-right: 5px;"></i>公共文件分享</span>-->
          <!--<el-form label-position="right" label-width="80px" :model="params">-->
            <!--<el-form-item label="有效期">-->
              <!--<el-radio-group v-model="params.expireTime" style="width: 100%;">-->
                <!--<div style="display: flex;flex-direction: row">-->
                  <!--<el-radio v-for="(item, idx) in invalidExpireOptions" :key="idx" :label=item.key style="width: 25%;">{{item.value}}</el-radio>-->
                <!--</div>-->
              <!--</el-radio-group>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
              <!--温馨提示：此操作可将文件分享给所有用户，请谨慎～-->
            <!--</el-form-item>-->
          <!--</el-form>-->
        <!--</el-tab-pane>-->
      </el-tabs>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="closeDialog">关 闭</el-button>
    <el-button v-if="!isCreateLink" size="mini" type="primary" @click="clickCreateLink" :loading="isLoading">{{btnText}}</el-button>
  </span>
  </el-dialog>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import ct from '../../utils/constant.js'
export default {
  props: ['openDialogVisiable', 'checkRowList'],
  mounted () {
    this.activeName = this.tabList[0].name
    this.isCloudAdmin = this.getStorage('isCloudAdmin')
    this.isCommonFileAdmin = this.getStorage('isCommonFileAdmin')
  },
  data () {
    return {
      tabList: [{label: '链接分享', name: 'linkShare'}],
      editableTabsValue: 2,
      activeName: '',
      count: 1,
      dirFileGuid: '',
      params: {
        fileGUIDs: [],
        needCode: ct.BooleanTF.yes,
        expireTime: ct.InvalidExpire.oneDay,
        comment: '',
        downloadFlag: ct.Boolean.no,
        category: ''
      },
      isCreateLink: false,
      isCopiedLink: false,
      isLoading: false,
      code: '', // 提取码
      shareUrl: '', // 分享链接
      isCloudAdmin: false,
      isCommonFileAdmin: false
    }
  },
  watch: {
  },
  methods: {
    ...mapMutations(['setFilesList']),
    closeDialog () {
      this.isCreateLink = false
      this.isCopiedLink = false
      this.$emit('closeDialog')
    },
    clickCreateLink () {
      let param = this.params
      param.category = this.isLinkShare ? ct.ShareType.regular : ct.ShareType.common
      let row = this.checkRowList
      let fileGUIDs = []
      row.forEach(e => {
        fileGUIDs.push(e.fileGuid)
      })
      param.fileGUIDs = fileGUIDs
      if (this.isFileShare) {
        param.needCode = ct.BooleanTF.no
        param.comment = ''
        param.downloadFlag = ct.Boolean.no
      }
      this.isLoading = true
      this.postRequest('generateShareRecord', param).then(res => {
        this.isLoading = false
        if (res.data.code === 0) {
          if (this.isFileShare) {
            this.$message({type: 'success', message: '操作成功～'})
            this.closeDialog()
          } else {
            this.shareUrl = res.data.result.shareUrl
            this.code = res.data.result.code
            this.isCreateLink = true
          }
        } else {
          this.$message({type: 'error', message: res.data.message})
        }
      })
    },
    clickCopyLink () {
      // console.log('clickCopyLink')
      let str = this.params.needCode ? '链接：' + this.shareUrl + '，提取码：' + this.code : '链接：' + this.shareUrl
      this.$copyText(str).then((e) => {
        this.isCopiedLink = true
        this.$message({message: '复制成功，快去发送给好友吧～', type: 'success'})
      })
    },
    getFileGuids () {
      let fileGuids = []
      this.checkRowList.forEach(f => {
        fileGuids.push(f.fileGuid)
      })
      return fileGuids
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    }
  },
  computed: {
    ...mapState(['computedHeight', 'cusDirFile', 'rootFile', 'filesList']),
    dialogTitle () {
      let str = '分享文件(夹)：'
      let row = this.checkRowList
      if (row.length > 1) {
        return str + row[0].fileName + '等'
      }
      return str + row[0].fileName
    },
    copyTips () {
      if (this.params.needCode) {
        return '复制链接及提取码'
      }
      return '复制链接'
    },
    expireTime () {
      return this.getStorage('dictInvalidExpire')[this.params.expireTime]
    },
    invalidExpireOptions () {
      return this.getStorage('invalidExpireOptions')
    },
    isLinkShare () {
      return this.activeName === 'linkShare'
    },
    isFileShare () {
      return this.activeName === 'defaultFileShare'
    },
    btnText () {
      if (this.isLinkShare) {
        return '创建链接'
      } else if (this.isFileShare) {
        return '确认分享'
      }
    }
  }
}
</script>
<style>
  .dialog-body {
    overflow-y: auto;
  }
  .customer-share-dialog .el-dialog__body {
    padding: 0 20px;
    border: solid 1px gainsboro;
    height: 270px;
  }

  .radio-type {
    height: 25px;
    margin-left: -40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/Share.vue